import { SuccessIcon } from "./Icons";
import { ErrorIcon } from "./Icons";
import { FieldProps } from "../../types";
import { validators } from "../../languages";
import InputControl from "./InputControl";

export function EmailField(props: FieldProps) {
  const { formMethods, fieldClasses, inputWrapperClasses, inputClasses, disabled } = props;
  return (
    <InputControl
      fieldId="email"
      fieldName="email"
      fieldTitlePhraseKey="payment_step.field_labels.email"
      fieldType="email"
      fieldClasses={fieldClasses}
      inputWrapperClasses={inputWrapperClasses}
      inputClasses={inputClasses}
      formMethods={formMethods}
      attributes={{
        disabled: disabled,
        inputMode: "email",
        autoCapitalize: "off",
        autoCorrect: "off",
        autoComplete: "email",
        "data-lpignore": "true"
      }}
      labelClasses={"is-required"}
      errorIcon={<ErrorIcon />}
      successIcon={<SuccessIcon />}
      validators={[
        validators.required,
        validators.email,
        validators.emailStartPeriods,
        validators.emailEndPeriods,
        validators.emailDoublePeriods
      ]}
    />
  );
}

export default EmailField;
